// src/hooks/useShellIsMobile.ts
import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useIsMobile } from '@/hooks/useIsMobile'

const LEGACY_MOBILE_MAX_WIDTH = 800

/**
 * Corte de celular da casca (Sidebar, Header, DashboardLayout), que vale para o app inteiro.
 *
 * - Flag `enabledDashboardMobile` ligada: o corte único da spec (D5, < 768px) mais o celular
 *   deitado, igual ao `isMobileLayout` do dashboard — a casca não pode roubar altura de um
 *   aparelho com 390px de altura.
 * - Flag desligada: exatamente o `window.innerWidth < 800` de hoje, para nenhuma rota mudar
 *   fora da flag (rollback = desligar a flag).
 */
export function useShellIsMobile(): Readonly<Ref<boolean>> {
  const { flags } = useFeatureFlags()
  if (flags.enabledDashboardMobile) return useIsMobile().isMobileLayout

  const isNarrow = ref(typeof window !== 'undefined' && window.innerWidth < LEGACY_MOBILE_MAX_WIDTH)
  const onResize = () => {
    isNarrow.value = window.innerWidth < LEGACY_MOBILE_MAX_WIDTH
  }
  onMounted(() => window.addEventListener('resize', onResize))
  onBeforeUnmount(() => window.removeEventListener('resize', onResize))
  return isNarrow
}
